import {
    Card,
    CardContent,
    CardHeader,
    Collapse,
    Grid,
    IconButton,
    Skeleton,
    Stack,
    Typography
} from "@mui/material"
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import React, {useEffect, useState} from "react";
import {FontSubtitleTwo} from "../../solicitation-new/components/SharedTypography";
import CardDocumentationContent from "./CardDocumentationContent";
import ChipCompleted from "../../../components/misc/ChipCompleted";
import ChipPendant from "../../../components/misc/ChipPendant";
import {FileBase, FileBaseFields} from "../../../types/solicitation/solicitationFile";
import {HttpSolicitationFiles} from "../../../http/solicitation/httpSolicitationFiles";
import {
    SolicitationFileRequestedView,
    SolicitationRequestDocumentationView,
    SolicitationRequestDocumentationViewFields
} from "../../../types/solicitation/solicitationData";
import {EntityWithIdFields} from "../../../types/baseEntities";
import {fileFormatter} from "../../../utils/formatters/fileFormatter";
import {HttpFiles} from "../../../http/files/httpFiles";
import {DeleteIconButton, DownloadIconButton, SearchIconButton} from "../../../components/buttons/Buttons";
import DialogPreviewFile from "../../../components/dialog/DialogPreviewFile";
import DeleteDialog from "../../../components/dialog/DeleteDialog";

interface CardDocumentacion {
    companyId: number,
    solicitationId: number,
    doc: SolicitationRequestDocumentationView,
    onReload: () => void,
    size?: 'small' | 'medium' | 'large',
    canDelete?: boolean
}



const CardDocumentation = (props: CardDocumentacion) => {
    const { companyId, solicitationId, doc, onReload } = props
    const [state, setState] = useState<'ok' | 'pendant'>(doc[SolicitationRequestDocumentationViewFields.AchievedDocumentsQuantity] !== 0 ? 'ok' : 'pendant')
    const [collapse, setCollapse] = useState<boolean>(state !== 'ok')
    const [uploadedFiles, setUploadedFiles] = useState<SolicitationFileRequestedView[]>()
    const [fileName, setFileName] = useState<string>()
    const [fileBlob, setFileBlob] = useState<any>()
    const [openPreview, setOpenPreview] = useState<boolean>(false)
    const [loading, setLoading] = useState<boolean>(false)
    const [openDelete, setOpenDelete] = useState<boolean>(false)
    const [docDeleteId, setDocDeleteID] = useState<number>()

    console.log(doc[SolicitationRequestDocumentationViewFields.AchievedDocumentsQuantity] + ' ' + doc[SolicitationRequestDocumentationViewFields.FileTypeDesc]);

    const saveNewDoc = (fileBase?: FileBase, file?: File, fileId?: number) => {
        return HttpSolicitationFiles.insertRequestedDoc(solicitationId, doc[EntityWithIdFields.Id], fileBase, file, fileId)
    }
    
    const loadUploads = () => {
        if(collapse && state === 'ok') {
            setLoading(true)
            HttpSolicitationFiles.getRequestedDocs(solicitationId, doc[EntityWithIdFields.Id]).then((r) => {
                setUploadedFiles(r)
                setLoading(false)
            })
        }
    }

    useEffect(() => {
        loadUploads()
    }, [collapse])
    
    useEffect(() => {
        loadUploads()
        setState(doc[SolicitationRequestDocumentationViewFields.AchievedDocumentsQuantity] !== 0 ? 'ok' : 'pendant')
    }, [onReload])

    const onDownloadFile = (file: SolicitationFileRequestedView) => {
        HttpFiles.download(file[EntityWithIdFields.Id])
            .then((data) => {
                const downloadUrl = window.URL.createObjectURL(new Blob([data]));

                const link = document.createElement('a');
                link.href = downloadUrl;

                link.setAttribute('download', file.descArchivo);

                document.body.appendChild(link);
                link.click();
                link.remove();
            });
    }

    const onDeleteFile = (fileId: number) => {
        setDocDeleteID(fileId)
        setOpenDelete(true)
    }

    const onDelete = () => {
        if (docDeleteId){
            HttpFiles.delete(docDeleteId)
                .then(() =>
                    onReload()
                )
        }
    }
    
    const onPreviewFile = (file: SolicitationFileRequestedView) => {
        setFileName(file[FileBaseFields.FileDesc])
        setLoading(true)
        
        HttpFiles.download(file[EntityWithIdFields.Id]).then((data) => {
            setFileBlob(data)
            setLoading(false)
            setOpenPreview(true)
        })
    }
    
    const onClosePreview = () => {
        setFileBlob(undefined)
        setOpenPreview(false)
    }
    
    const renderTitle = () => {
        return (
                <Stack direction='row' alignItems='center' spacing={2} justifyContent={'space-between'}>
                    <Stack spacing={1}>
                        <FontSubtitleTwo text={doc[SolicitationRequestDocumentationViewFields.FileTypeDesc]} />
                        <Typography color={"#b9babd"} fontWeight={500} fontSize={14}>
                            {doc[SolicitationRequestDocumentationViewFields.RequestDocumentationDesc]}
                        </Typography>
                    </Stack>
                    {
                        state === 'ok' ?
                            <ChipCompleted/>
                            :
                            <ChipPendant />
                    }
                </Stack>
        )
    }

    return (
        <Card>
            <CardHeader
                title={renderTitle()}
                action={
                    <IconButton onClick={() => setCollapse((collapsed) => !collapsed)}>
                        {collapse ? <ExpandLessIcon />
                        : <ExpandMoreIcon />}
                    </IconButton>
                }
            />
            <Collapse in={collapse}>
                <CardContent>
                    {
                        state === 'pendant' ?
                            <CardDocumentationContent clientId={companyId}
                                                      onNewDoc={saveNewDoc}
                                                      fileType={doc[SolicitationRequestDocumentationViewFields.FileTypeCode]}
                                                      onReload={onReload}
                                                      size={props.size}
                            />
                            :
                            <Grid container gap={2}>
                                { loading ? 
                                    Array.from({length: 3}).map((d, idx) => <Grid item md={2} key={idx}><Skeleton height={200}/></Grid>)
                                    :
                                    uploadedFiles?.map((f, idx) => 
                                        <Grid key={idx} item md={2} textAlign={'center'} 
                                              sx={{p: 2,
                                                  borderColor: 'grey',
                                                  borderRadius: '10px',
                                                  borderStyle: 'dashed',
                                                  borderWidth: '2px'
                                              }}>
                                            {fileFormatter.getIconByFileName(f[FileBaseFields.FileDesc], {fontSize: 'large'})}
                                            <Typography fontWeight={600} fontSize={14} sx={{ wordWrap: 'break-word' }}>{f[FileBaseFields.FileDesc]}</Typography>
                                            <Stack direction={'row'} spacing={2} alignItems={'center'} justifyContent={'center'} mt={1}>
                                                <DownloadIconButton onClick={() => {onDownloadFile(f)}} tooltipTitle={'Descargar'} />
                                                <SearchIconButton onClick={() => {onPreviewFile(f)}} tooltipTitle={'Previsualizar'} />
                                                {
                                                    props.canDelete &&
                                                    <DeleteIconButton onClick={() => {onDeleteFile(f[EntityWithIdFields.Id])}} tooltipTitle={'Eliminar'} color={"error"}/>
                                                }

                                            </Stack>
                                        </Grid>
                                    )
                                }
                            </Grid>
                    }
                    {
                        fileBlob && fileName &&
                        <DialogPreviewFile open={openPreview}
                                           onClose={onClosePreview}
                                           fileBlob={fileBlob}
                                           fileName={fileName}
                        />
                    }
                    {
                        props.canDelete &&
                        <DeleteDialog open={openDelete}
                                      onClose={() => {
                                          setOpenDelete(false)
                                          setDocDeleteID(undefined)
                                      }}
                                      onDelete={onDelete}
                                      title={'Eliminar documento'}
                                      description={'�Est� seguro de querer eliminar el documento?'}
                        />
                    }
                </CardContent>
            </Collapse>
        </Card>
    )
}

export default CardDocumentation